<template>
    <DModal
        :show="showModal"
        :title="__('customers.contracts.force_fulfill_confirm_title')"
        :message="__('customers.contracts.force_fulfill_confirm_message')"
        is-confirm
        is-error
        @confirm="confirmForceFulfill"
        @update:show="$emit('update:showModal', $event)"
        @close="emit('close-modal')"
    />
</template>

<script setup>
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const props = defineProps({
    contract: {
        type: Object,
        default: () => { return {} }
    },
    showModal: {
        type: Boolean,
        default: false
    }
})
const emit = defineEmits(['close-modal', 'update:showModal'])

const confirmForceFulfill = () => {
    router.post(route('customers.customers.contracts.force-fulfill-email-verification', {
        customer: props.contract.customer_id,
        contract: props.contract.id
    }), {}, {
        onSuccess: () => {
            emit('close-modal')
        }
    })
}
</script>
